/**
 *
 * SMS Table
 *
 */

import React, { FC, useEffect } from 'react';

import { Clients } from '@ariksa/notification';
import { Box } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomTable2 as Table } from 'components/DataDisplay/NewTable/Table';
import { renderTime, WithResourceIcon } from 'components/index';
import { DeleteClientModal } from 'containers/Setup/Integrations/Components/Utils/DeleteClientModal';
import { useIntegrations } from 'containers/Setup/Integrations/hooks/useIntegrations';
import { selectIntegrations } from 'containers/Setup/Integrations/selectors';
import { actions as clientActions } from 'containers/Setup/Integrations/slice';

export const SMSTable: FC = () => {
  const { clients, client } = useSelector(selectIntegrations);
  const dispatch = useDispatch();
  const { clientActionsColumn, ...rest } = useIntegrations();

  useEffect(() => {
    dispatch(
      clientActions.loadClients({
        clientName: Clients.Sns,
      }),
    );
  }, [dispatch]);

  const columns = [
    {
      header: <Box pl={16}>Name</Box>,
      accessor: 'name',
      render: ({ value }) => (
        <WithResourceIcon resourceType={Clients.Sns} spacing={10}>
          {value}
        </WithResourceIcon>
      ),
    },
    {
      header: 'Created By',
      accessor: 'created_by',
      styles: {
        textAlign: 'left',
        cell: { textAlign: 'left' },
      },
    },
    {
      header: 'Created on',
      accessor: 'created_at',
      render: renderTime,
    },
    clientActionsColumn,
  ];

  return (
    <>
      <Table
        columns={columns}
        data={clients.sns}
        isLoading={clients.loading || client.isLoading}
      />
      {rest.isOpenDeleteClientModal && (
        <DeleteClientModal label="Delete SMS" {...rest} />
      )}
    </>
  );
};
